/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2"
import { comma } from "../../utils/number";
import { get, isEmpty, each, sumBy } from 'lodash'
// import { Distance, DistancePercent } from "../Distans";
import { CardHeader, CardTitle, CardUnit } from "../ContentLayout";
import Loading from "../Loading";
import NoData from "../NoData/NoData";
import { getDateRangeList, getDay, dateToViewFormat, getDayName, getYearRange } from "../../utils/date";
import { getFinancesStatistics } from "../../utils/financesStatistics";
import Select from "../Select";


const startAt = getDay(6);
// const startAt = getDay(30);
const endAt = getDay(1);
const dateRange = getDateRangeList(startAt, endAt)
// const params = {
//   "groupBy": "date",
//   startAt,
//   endAt,
//   dateRange
// }

const dataLabels = [
  {
    yAxesID: 'A',
    label: '매출',
    backgroundColor: '#FF5C6D',
    borderRadius: 5,
    data: [],
  },
  {
    yAxesID: 'A',
    label: '매입',
    backgroundColor: '#21D4A9',
    borderRadius: 5,
    data: [],
  },
  // {
  //   yAxesID: 'B',
  //   label: '은행잔고',
  //   type: 'line',
  //   fill: false,
  //   borderColor: "#7D8AFF",
  //   data: [],
  // },
]

const SalesBarChart = ({ isYearRange }) => {
  const [data, setData] = useState(null)
  const [options, setOptions] = useState(null)
  const [isLoading, setIsLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(`${new Date().getFullYear()}`)
  const [params, setParams] = useState({
    groupBy: isYearRange ? "month" : "date",
    startAt: isYearRange ? `${new Date().getFullYear()}-01-01` : getDay(6),
    endAt: isYearRange ? `${new Date().getFullYear()}-12-31` : getDay(),
  })

  useEffect(() => {
    submit()
  }, [params])

  const submit = async () => {
    setIsLoading(true)

    const {
      taxPurchase,
      taxSales,
      cardPurchase,
      cardSales,
      cashReceiptsPurchase,
      cashReceiptsSales,
      // banks,
    } = await getFinancesStatistics(params)

    // const bankTotals = []
    const purchaseTotals = []
    const salesTotals = []

    if (
      isEmpty(taxPurchase) &&
      isEmpty(taxSales) &&
      isEmpty(cardPurchase) &&
      isEmpty(cardSales) &&
      isEmpty(cashReceiptsPurchase) &&
      isEmpty(cashReceiptsSales)
    ) {
      setData({})
      setIsLoading(false)
      return
    }

    if (isYearRange) {
      const labels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      each(labels, (label) => {
        let dayPurchase = 0
        let daySales = 0
        const findTaxPurchase = taxPurchase.find(item => item.month === label)
        const findCardPurchase = cardPurchase.filter(item => item.month === label)
        const findCashReceiptsPurchase = cashReceiptsPurchase.find(item => item.month === label)
        //dayPurchase += get(findTaxPurchase, 'totalAmt', 0)
        dayPurchase += get(findTaxPurchase, 'supplyAmt', 0)
        dayPurchase += sumBy(findCardPurchase, 'useAmt')
        dayPurchase += get(findCashReceiptsPurchase, 'totAmt', 0)

        const findTaxSales = taxSales.find(item => item.month === label)
        const findCardSales = cardSales.find(item => item.month === label)
        const findCashReceiptsSales = cashReceiptsSales.find(item => item.month === label)

        //daySales += get(findTaxSales, 'totalAmt', 0)
        daySales += get(findTaxSales, 'supplyAmt', 0)
        daySales += get(findCardSales, 'buyAmt', 0)
        daySales += get(findCashReceiptsSales, 'totAmt', 0)
        purchaseTotals.push(Math.round(dayPurchase / 1000));
        salesTotals.push(Math.round(daySales / 1000))
      })
      setData({
        labels: labels.map((label) => `${label}월`),
        datasets: [
          {
            ...dataLabels[0],
            data: salesTotals,
          },
          {
            ...dataLabels[1],
            data: purchaseTotals,
          },
        ],
      })
    } else {
      each(dateRange, (date) => {
        let dayPurchase = 0
        let daySales = 0
        const findTaxPurchase = taxPurchase.find(item => item.date === date)
        const findCardPurchase = cardPurchase.filter(item => item.date === date)
        const findCashReceiptsPurchase = cashReceiptsPurchase.find(item => item.date === date)

        const findTaxSales = taxSales.find(item => item.date === date)
        const findCardSales = cardSales.find(item => item.date === date)
        const findCashReceiptsSales = cashReceiptsSales.find(item => item.date === date)
        // const findBank = banks.find(item => item.date === date)

        //dayPurchase += get(findTaxPurchase, 'totalAmt', 0)
        dayPurchase += get(findTaxPurchase, 'supplyAmt', 0)
        dayPurchase += sumBy(findCardPurchase, 'useAmt')
        dayPurchase += get(findCashReceiptsPurchase, 'totAmt', 0)

        //daySales += get(findTaxSales, 'totalAmt', 0)
        daySales += get(findTaxSales, 'supplyAmt', 0)
        daySales += get(findCardSales, 'buyAmt', 0)
        daySales += get(findCashReceiptsSales, 'totAmt', 0)


        // let balanceAmt = beforeBankAmt
        // if (findBank) {
        //   beforeBankAmt = findBank.balanceAmt
        //   balanceAmt = findBank.balanceAmt
        // }

        // bankTotals.push(Math.round(balanceAmt / 10000))
        purchaseTotals.push(Math.round(dayPurchase / 1000));
        salesTotals.push(Math.round(daySales / 1000))
      })

      setData({
        labels: dateRange.map(date => `${dateToViewFormat(date, 'DD')} (${getDayName(date)})`),
        datasets: [
          {
            ...dataLabels[0],
            data: salesTotals,
          },
          {
            ...dataLabels[1],
            data: purchaseTotals,
          },
          // {
          //   ...dataLabels[2],
          //   data: bankTotals,
          // },
        ],
      })
    }
    setOptions({
      tooltips: {
        callbacks: {
          title: function (tooltipItem, data) {
            return tooltipItem[0].xLabel
          },
          label: function ({ datasetIndex, index, label: totalLabel }, data) {
            // return data.datasets.map(d => `${d.label} : ${comma(d.data[index])}원`)
            const target = data.datasets[datasetIndex]
            return `${target.label} : ${comma(target.data[index])}천원`

          }
        }
      },
      isStacked: true,
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            display: true,
            gridLines: {
              color: 'transparent',
              zeroLineColor: 'transparent'
            },
          },
        ],
        yAxes: [
          {
            // display: false,
            id: 'A',
            type: 'linear',
            position: 'left',
            ticks: {
              // min: 0,
              // max: max(datas) * 1.2,
              // max: max([...datas, ...datas2]),
              callback: function (value, index, values) {
                return `${comma(value)}`
              },
            },
          },
          // {
          //   id: 'B',
          //   type: 'linear',
          //   position: 'right',
          //   // ticks: {
          //   //   // min: 0,
          //   //   max: max(bankTotals),
          //   //   callback: function(value, index, values) {
          //   //     return `${comma(value)}`
          //   //   },
          //   // },
          // },
        ],
      },
      plugins: {
        datalabels: {
          display: false
          // anchor: "end",
          // color: datas.map(
          //   (data, idx) =>
          //     "#334060"
          // ),
          // align: "top",
          // offset: -4,
          // font: {
          //   weight: "bold",
          //   size: 15
          // },
          // formatter: (value) => {
          //   return comma(value)
          // },
        },
      },
    })
    setIsLoading(false)

  }

  const handleOnChangeYear = (e) => {
    const { value } = e.target
    setSelectedYear(value)
    setParams({
      ...params,
      startAt: `${value}-01-01`,
      endAt: `${value}-12-31`,
    })
  }

  return <div className="sales-chart">
    {isLoading ?
      <Loading color={"#5C6DFF"} /> :
      <>
        <CardHeader style={{
          height: '80px'
        }}>
          <CardTitle>
            매출/매입 현황
          </CardTitle>
          <div className="chart-info">
            {dataLabels.map((data, key) => <span key={key} className="chart-data-info">
              <span
                className="ball"
                style={{
                  backgroundColor: data.backgroundColor || data.borderColor
                }}
              ></span> {data.label}
            </span>)}
            <span className="chart-unit">
              (증빙자료 기준, 단위 : 천원)
            </span>
          </div>
          {isYearRange && (
            <CardUnit>
              <Select
                value={selectedYear}
                onChange={handleOnChangeYear}
                list={getYearRange()}>
              </Select>
            </CardUnit>
          )}
        </CardHeader>
        <div className="seles-chart-box pt-15" >
          {/* <span className="chart-unit">단위 : 천원</span> */}
          {
            isEmpty(data) ? <NoData /> : <Bar
              data={data}
              options={options}
              height={120}
            />
          }
        </div>
      </>}
  </div>
}

export default SalesBarChart